<template>
    <div class="main">
        <!-- title -->
        <h3 class="title" content="edit" placement="bottom">
        Content Management - Generic Contents
        <el-button
            style="width:180px"
            type="primary"
            @click="handleAdd()"
            v-if="$store.state.userLevel <= 2"
            >Create</el-button
        >
        </h3>

        <!-- toolbar, table & pagination share one panel -->
        <div class="client-panel">
          <div class="client-panel__toolbar">
            <columns-control
              :columns="columnsConfig"
              storage-key="cms.genericContents.columns"
              @change="onColumnsChange"
            ></columns-control>
          </div>
          <el-table :data="tableData">
            <el-table-column v-if="isColumnVisible('id')" prop="id" label="Id"></el-table-column>
            <el-table-column v-if="isColumnVisible('type')" prop="type" label="Type"></el-table-column>
            <el-table-column v-if="isColumnVisible('field')" prop="field" label="Field"></el-table-column>
            <el-table-column v-if="isColumnVisible('createdByName')" prop="createdByName" label="Created By"></el-table-column>
            <el-table-column label="Operation">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                  <em
                    class="edit"
                    style="margin-right: 10px"
                    @click="handleEdit(scope.row)"
                  ></em>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Delete"
                  placement="top"
                >
                  <em class="delete" @click="handleDelete(scope.row)"></em>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- page -->
          <app-pagination
            @size-change="
              v => {
                currentSize = v;
                currentPage = 1;
                getContents();
              }
            "
            @current-change="
              v => {
                currentPage = v;
                getContents();
              }
            "
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50]"
            :total="total"
            :page-size="currentSize"
          ></app-pagination>
        </div>
    </div>
</template>
<script>
import {
  contentList,
  contentDelete
} from "@/request/api";
export default {
  name: "genericContents",
  data() {
    return {
        tableData: [],
        ProductsList: [],
        currentSize: 10,
        currentPage: 1,
        total: 0,
        formLabelWidth: "96px",
        formUser: {
          id: 0,
          username: "",
          password: "",
          roles: []
        },
        formInline: {
          projectName: ""
        },
        formFilter: {
          type: "All"
        },
        sort: ["name.EN,asc", "id,asc"],
        typeList: [],
        statusList: [],
        locationList: [],
        postList: [
          { name: "Online", code: true },
          { name: "Offline", code: false }
        ],
        columnsConfig: [
          { prop: "id", label: "Id", visible: true },
          { prop: "type", label: "Type", visible: true },
          { prop: "field", label: "Field", visible: true },
          { prop: "createdByName", label: "Created By", visible: true },
        ],
        visibleColumnProps: ["id", "type", "field", "createdByName"],
    };
  },
  methods: {
    isColumnVisible(prop) {
      return this.visibleColumnProps.includes(prop);
    },
    onColumnsChange(visibleProps) {
      this.visibleColumnProps = visibleProps;
    },
    getContents(val) {
      let params = {
        page: this.currentPage - 1,
        size: this.currentSize,
        sort: this.sort
      };
      contentList(params).then(res => {
        this.tableData = res.data.content;
        this.total = res.data.totalElements;
      });
    },
    handleAdd() {
      this.$router.push({ path: "/createGenericContent" });
    },
    handleEdit(row) {
      this.$router.push({ path: "/editGenericContent/" + row.id });
    },
    handleDelete(row) {
        const h = this.$createElement;
        this.$msgbox({
          message:h('div',{style:'padding:15px 0'},[
            h('p',{style:'color:#003448;text-align:center;font-size:20px;font-weight:bold;line-height: 1.5;'},'Are you sure to delete this record?'),
          ]),
          showCancelButton: true,
          confirmButtonText:'Confirm',
          cancelButtonText:'Cancel',
          confirmButtonClass:'msg_button_half',
          cancelButtonClass:'msg_button_half',
          closeOnPressEscape:false,
          closeOnClickModal:false,
          callback:(action,instance)=>{
            let button = action;
            if(button == 'confirm'){
              contentDelete(row.id).then(res=>{
                if(res.data.status == '00'){
                  this.$message.success('Reocrd is deleted');
                  this.getContents();
                }else{
                  this.$message.error(res.data.msg)
                }
              })
            }
          }
        })
    },
  },
  created: function() {
    this.$emit("header", true);
    this.getContents();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "editProject") {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  activated() {
    if (this.$route.params.update) {
      this.getContents();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.client-panel {
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 8px;
  overflow: hidden;
}

.client-panel__toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 20px;
  border-bottom: 1px solid #e6ebee;
}

.client-panel /deep/ .el-table {
  border: none;
  border-radius: 0;
}

.client-panel /deep/ .app-pagination {
  margin-top: 0;
  border: none;
  border-radius: 0;
  border-top: 1px solid #e6ebee;
}
</style>



// WEBPACK FOOTER //
// src/components/content/genericContent/genericContent.vue